module.exports = __webpack_public_path__ + "static/media/display-3.65735db5.png";